import React from 'react';
import { useTranslation } from 'react-i18next';

const ProtectedEmailLink = ({ user, domain, text }) => {
  const { t } = useTranslation();

  if (!user || !domain) return null;

  const labelStr = typeof text === 'string' ? text : '';
  const plain = labelStr.replace(/<[^>]*>/g, '').trim();
  const isEmpty = !plain;

  return (
    <a
      href="#"
      onClick={async (e) => {
        e.preventDefault();
        const a = document.createElement('a');
        a.href = `mailto:${user}@${domain}`;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        a.remove();
      }}
      title={t('Poslať e-mail')}
      style={{
        cursor: 'pointer',
        textDecoration: 'underline',
        color: '#1677ff',
      }}
    >
      {isEmpty ? (
        <i className="fa-regular fa-envelope"></i>
      ) : (
        <span dangerouslySetInnerHTML={{ __html: labelStr }} />
      )}
    </a>
  );
};

export default ProtectedEmailLink;
